module.exports = __webpack_public_path__ + "media/images/bg_image/img_bg_image_expanding_fiber-568c4845b9668491302a885f3a856f16.jpg";